import axios from "axios";
import { useEffect, useState } from "react";
import { Line, Pie } from "react-chartjs-2";
import Footer from "../components/Footer";
import Startbar from "../components/Startbar";
import Topbar from "../components/Topbar";
import { BASE_URL } from "../config";

import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [summary, setSummary] = useState({
    total_income: 0,
    total_expense: 0,
    balance: 0,
    recent_transactions: [],
    pieData: {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    },
    lineData: {
      labels: [],
      datasets: [],
    },
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not found. Please login again.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/dashboard-summary`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Use response.data directly (no nested data)
        if (response.data) {
          console.log("Dashboard data:", response.data);
          setSummary(response.data);
        } else {
          console.error("Invalid response structure", response);
        }
      } catch (error) {
        console.error("Failed to load dashboard summary", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>Loading Dashboard...</div>
      </div>
    );
  }

  return (
    <>
      <Topbar />
      <Startbar />
      <div className="page-wrapper">
        <div className="page-content">
          <div className="container-xxl">
            <div className="row mb-4">
              {/* Total Balance */}
              <div className="col-md-4">
                <div className="card text-center p-3">
                  <h5>Total Balance</h5>
                  <h2>{Number(summary.balance).toFixed(2)} ৳</h2>
                </div>
              </div>

              {/* Total Income */}
              <div className="col-md-4">
                <div className="card text-center p-3 text-success">
                  <h5>Total Income</h5>
                  <h2>{Number(summary.total_income).toFixed(2)} ৳</h2>
                </div>
              </div>

              {/* Total Expense */}
              <div className="col-md-4">
                <div className="card text-center p-3 text-danger">
                  <h5>Total Expense</h5>
                  <h2>{Number(summary.total_expense).toFixed(2)} ৳</h2>
                </div>
              </div>
            </div>

            {/* Pie Chart */}
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="card p-3">
                  <h5>Expense by Category</h5>
                  {summary.pieData.labels.length > 0 ? (
                    <Pie data={summary.pieData} />
                  ) : (
                    <p>No expense data available.</p>
                  )}
                </div>
              </div>

              {/* Line Chart */}
              <div className="col-md-6">
                <div className="card p-3">
                  <h5>Monthly Income vs Expense</h5>
                  {summary.lineData.labels.length > 0 ? (
                    <Line data={summary.lineData} />
                  ) : (
                    <p>No monthly data available.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Latest 5 Transactions */}
            <div className="row">
              <div className="col-12">
                <div className="card p-3">
                  <h5>Recent Transactions</h5>
                  {summary.recent_transactions.length > 0 ? (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {summary.recent_transactions.map((txn) => (
                          <tr key={txn.id}>
                            <td>{txn.date}</td>
                            <td>{txn.category}</td>
                            <td
                              className={
                                txn.type === "income"
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {txn.type}
                            </td>
                            <td>{Number(txn.amount).toFixed(2)} ৳</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No recent transactions available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
